<template>
    <Modal
        v-model="show"
        title="投保重要提示"
        :closable="false"
        :mask-closable="false"
        @on-ok="ok"
        @on-cancel="cancel"
        ok-text="同意并继续"
        cancel-text="取消">
        <p class="notice-content">
           <span>您即将进入投保流程：</span><br>
           请仔细阅读保险条款等内容，为保障您的权益，您在销售页面的操作将会被记录并加密存储，同时页面输入的信息将仅用于投保
        </p>
    </Modal>
</template>
<script>
export default {
    props:{
        companyName:String
    },
    data () {
        return {
            show:true
        }
    },
    methods:{
        ok () {

        },
        cancel () {
            this.$router.go(-1);
            // window.close();
            // window.history.back();
        }
    }
}
</script>
<style scoped lang="less">
    .notice-content{
        font-size: 1em;
        span {
            font-weight: bold;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/TrackNotice.vue